// The hero graphic is a working code, generated from the real URL rather
// than drawn to look like one. Regenerate with business-cards/make_assets.py
// if the target ever changes.
export const QR_TARGET = "https://sipnscore.co.za/demo/";
export const QR_SIZE = 33;
export const QR_ROWS = [
  "111111100010001011101001101111111",
  "100000100101100100011111001000001",
  "101110100101101001110001001011101",
  "101110100000011111011011101011101",
  "101110101010101001000111101011101",
  "100000100000010100110101001000001",
  "111111101010101010101010101111111",
  "000000001101011101100010100000000",
  "001100111010001101110101011010000",
  "111101000001011010111101111001001",
  "010110100000000001011001110001111",
  "001011010001111011010000011111001",
  "101100100111001011111100110100000",
  "100111001001011110010110110000100",
  "000001110101100100000100101101000",
  "110111010111010001000111101011110",
  "011111101011110110000101111011110",
  "100111001100001001011011001010111",
  "011111110010011110110000011010110",
  "010101001010000101100000000110011",
  "000110110110101011110100101001100",
  "111000011001100101001100100000001",
  "000111110001100100010011101000001",
  "010001000001100010011010010011000",
  "101101101010111011101010111111010",
  "000000001000000100111101100011010",
  "111111101100000100000101101011100",
  "100000100000111001011001100011111",
  "101110100101011110010011111111110",
  "101110101101001001110110100101100",
  "101110101111010010100000011001000",
  "100000100001101101101101101001001",
  "111111100010010000001001001110100",
];
